import { useCallback } from "react";
import { useProtectedAPI } from "./apiService";
import { objectToQueryString } from "@/utils/objectToQueryString";
import useSWR from "swr";



export const useGetSkillsSWR = (competition_id) => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( competition_id ? "/whoiswho/skills?competition_id=" + competition_id : "/whoiswho/skills", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useGetCompetitionsSWR = () => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( "/whoiswho/competitions", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useGetRegionsSWR = () => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( "/whoiswho/regions", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useGetUsers = () => {

    const protectedAPI = useProtectedAPI()

    const getUsers = useCallback(async (filters) => {
        const queryString = objectToQueryString(filters)
        const url = `/whoiswho/?${queryString}`
        const response = await protectedAPI.get(url)
        return [response.data, response.headers["x-total-count"]]
    }, [protectedAPI])

    return getUsers
     
}



export const useChangePassword = () => {
    const protectedAPI = useProtectedAPI();

    const changePassword = useCallback(async (id) => {
        const response = await protectedAPI.post(`/whoiswho/password?id=${id}`);
        return response.data;
    }, [protectedAPI])

    return changePassword;
}



export const useChangePicture = () => {
    const protectedAPI = useProtectedAPI();

    const changePicture = useCallback(async (id, file) => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await protectedAPI.post(`/whoiswho/picture?id=${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return changePicture;
}



export const useDeletePicture = () => {
    const protectedAPI = useProtectedAPI();

    const deletePicture = useCallback(async (id) => {
        const response = await protectedAPI.delete(`/whoiswho/picture?id=${id}`, {
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return deletePicture;
}